<template>
  <div id="app">
    <div style="margin:0 auto;text-align:left;">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data(){
    return {
      queryParams: {
        lang: 'zh'
      }
    }
  },
  created(){
  },
  mounted() {
    if(this.$route.path === '/posterPage'){
      document.title = 'Function Preview'
    }
  },
  methods:{
    getQueryParams() {
      return new Promise((resolve) => {
        const params = {};
        const queryString = window.location.search.substring(1);
        const pairs = queryString.split("&");
        for (let pair of pairs) {
          const [key, value] = pair.split("=");
          params[decodeURIComponent(key)] = decodeURIComponent(value);
        }
        this.queryParams = params;
        resolve(params);
      });
    },
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background: linear-gradient(180deg, #F9EAE7 17%, #FCF9F7 70%, #F5F5F5 100%); */
  background: #F5F5F5;
  height: 100vh;
  
}
*{
    margin: 0;
    padding: 0;
}
</style>
